<template>
  <el-dialog 
    :modal-append-to-body="false"
    :title="openType === 'add' ? '新增导航' : '编辑导航'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="50%"
    custom-class="customModal">
    <el-form ref="form" :model="formValue" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="name" class="formItemFill" label="导航名称">
            <el-input v-model="formValue.name" size="small" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="数据类型" prop="data_type" class="formItemFill">
            <el-select v-model="formValue.data_type" placeholder="请选择" size="small" style="width: 100%;"  @change="typeChange">
              <el-option
                v-for="item in data_type"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="导航类型" prop="nav_type" class="formItemFill">
            <el-select v-model="formValue.nav_type" placeholder="请选择" size="small" style="width: 100%;" :disabled="this.activeName!=='all'">
              <el-option
                v-for="item in nav_type"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="this.formValue.data_type === 'custom'">
          <el-form-item prop="url" class="formItemFill" label="url" >
            <el-input v-model="formValue.url" size="small" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-else>
          <el-form-item prop="data_name" class="formItemFill" label="数据名称">
            <el-cascader
              v-model="formValue.value"
              :options="data_name"
              style="width: 100%"
              :props="{ checkStrictly: this.formValue.data_type === 'goods_category', children: 'sub', label: 'name', value: 'id' }"
              ></el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="sort" class="formItemFill" label="顺序" >
            <el-input type="number" v-model.number="formValue.sort" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="父级菜单" prop="pids" class="formItemFill">
            <el-cascader
              size="small"
              style="width: 100%"
              ref="cascader"
              v-if="formValue.pids && formValue.pids.length"
              v-model="formValue.pids"
              :options="treeData"
              :props="{ checkStrictly: true, children: 'child', label: 'name', value: 'id' }"
              ></el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="是否显示">
        <el-radio-group v-model="formValue.is_show" size="small" style="width: 100%">
          <el-radio-button :label="true">是</el-radio-button>
          <el-radio-button :label="false">否</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <AppButton type="primary" @click="submit" size="small">提交</AppButton>
      <AppButton @click="close" size="small">取 消</AppButton>
    </div>
  </el-dialog>
</template>

<script>
import { WebsiteService } from '../../service/website.service';
import { ArticleService } from '../../service/article.service';
import { GoodsService } from '../../service/goods.service'
  export default {
    props: ['activeName'],
    name: 'formRotationChart',
    data() {
      return {
        visible: false,
        openType: '',
        formValue: { },
        treeData: [],
        nav_type:[],//导航类型
        data_type: [],//数据类型
        data_type_goods:[],//商品类型
        data_type_article:[],//文章类型
        data_type_customview:[],//自定义页面
        data_name: [],//数据名称(用来渲染次联选择器)
        rules: {
          name: [{ required: true, message: '名称不能为空'}],
          data_type: [{ required: true, len: 1, message: '请选择数据类型', trigger: 'check' }],
          nav_type: [{ required: true, len: 1, message: '请选择导航类型', trigger: 'check' }],
          router_url: [{ required: true, message: '请输入router_url', trigger: 'blur'}],
          url: [{ required: true, message: '请输入url',trigger: 'blur' }],
          sort: [{ required: true, message: '顺序不能为空'}]
        }
      }
    },
    methods: {
      async open(type, data,activeName,nav_type,item_data) {
        this.treeData = [{
          id: 0,
          name: '根菜单',
          child: []
        }]
        this.data_type_goods = data.goods_cat
        this.data_type_article = data.article_cat
        this.data_type_article.forEach(item=>{
          if(item.sub.length<1){
            item.disabled = true
          }else{
            item.sub.forEach(val=>{
              val.name = val.title
            })
          }
        })
        this.data_type_customview = data.custom_view
        this.data_type_customview.list.forEach(val=>{
          val.name = val.title
        })
        this.data_type = data.data_type
        this.nav_type = nav_type
        switch (activeName) {
          case 'header':
            this.treeData[0].child = data.header
            break
          case 'middle':
            this.treeData[0].child = data.middle
            break
          case 'footer':
            this.treeData[0].child = data.footer
            break
        }
        if (type === 'add') {
          this.reset();
        } else if (type === 'edit' && item_data) {
          const dataDetail = JSON.parse(JSON.stringify(await WebsiteService.getNavigationListDetail(item_data.id)))
          delete dataDetail.child
          dataDetail.pids = this.findParents(this.treeData,dataDetail.pid)
          this.formValue = dataDetail
          switch (this.formValue.data_type) {
            case 'customview':
              console.log(this.data_type_customview.list)
              this.data_name = this.data_type_customview.list
              break
            case 'article_class':
              this.data_name = this.data_type_article
              break
            case 'goods_category':
              this.data_name = this.data_type_goods
              break
          }
        }
        
        this.openType = type;
        this.visible = true;
      },
      getTreeData(data) {
        for(let i = 0; i< data.length; i++) {
          if(data[i].sub) {
            if(data[i].sub.length<1){
              data[i].sub = undefined
            }else{ 
              this.getTreeData(data[i].sub)
            } 
          }
          
        }
      },
      findParents(treeData, id) {
        if (treeData && treeData.length) {
          for (let i = 0; i < treeData.length; i++) {
            if (treeData[i].id === id) {
              return [ id ];
            }
            const found = this.findParents(treeData[i].child, id);
            if (found) {
              found.unshift(treeData[i].id);
              return found;
            }
          }
        }
      },
      reset() {
        this.formValue = {
          sort: 50,
          pids: [0],
          data_type: 'custom',
          url: ''
        };
        this.formValue.nav_type = this.activeName
      },
      close() {
        this.visible = false;
        this.formValue = {};
      },
      async update() {
        const data = await WebsiteService.getNavigationList();
        this.treeData = [{
          id: 0,
          name: '根菜单',
          child: data
        }];
      },
      async submit() {
          this.formValue.pid = this.formValue.pids[this.formValue.pids.length -1 ]
          this.formValue.value = this.formValue.value[this.formValue.value.length -1 ]
          delete this.formValue.pids
          delete this.formValue.child
          this.formValue.is_show = this.formValue.is_show ? 1 :0
          await WebsiteService.submitNavigation(this.formValue);
          this.$emit('submitSuccess')
          this.update();
          this.close();
      },
      async typeChange() {
        if(this.formValue.data_type === 'customview') {
          this.data_name = this.data_type_customview.list
        }else if(this.formValue.data_type === 'article_class') {
          console.log(this.data_type_article.cat_list)
          this.data_name = this.data_type_article
        }else if(this.formValue.data_type === 'goods_category') {
          this.data_name = this.data_type_goods
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

.treeTable {
  height: 29vw;
  overflow-y: auto;
  overflow-x: hidden;
}

</style>